import { Box } from '@mui/material'
import AgentQuestionBlock from '@/components/ChatResponseElements/AgentQuestionBlock'
import styles from './index.module.scss'

/**
 * @param {{
 *   question: import('@/features/chat/agentQuestion/agentQuestionTypes.js').AgentQuestionPayload,
 *   onConfirm?: (p: { optionId: string, freeText?: string }) => void,
 * }} props
 */
export default function AiAskBarAgentQuestionSection({ question, onConfirm }) {
  return (
    <Box className={styles.agentQuestionSection}>
      <Box className={styles.agentQuestionInner}>
        <AgentQuestionBlock
          prompt={question.prompt}
          options={question.options}
          status={question.status}
          agentBrand={question.agentBrand}
          agentName={question.agentName}
          freeTextOptionId={question.freeTextOptionId ?? 'd'}
          interactive
          onConfirm={onConfirm}
        />
      </Box>
    </Box>
  )
}
